import { useQuery } from "@tanstack/react-query"
import { listProducts } from "../../products"
import { notification } from "antd"

export const useListProducts = ({ params }) => {
    const handleError = (err) => {
        notification.error({
            key: "listProductError",
            message: "Failed to retrieve products list"
        })
    }

    return useQuery({
        queryKey: ["listProducts", params],
        queryFn: () => listProducts(params),
        onError: handleError,
    })
}
